import React from 'react'
import {Form, Input, Button, notification} from 'antd'
import { useData } from '../../../data'
import {trackPromise, usePromiseTracker} from 'react-promise-tracker'
import PropTypes from 'prop-types'

/**
 * Has controls to change a user password
 */
const UpdatePassword = ({user}) => {
    const data = useData()
    const auth = data.auth()
    const [form] = Form.useForm()

    const updatePassword = vals => {
        const {password, password_confirm} = vals

        if(password !== password_confirm){
            form.setFields({
                password_confirm: {
                    errors: [new Error("Passwordd do not match")]
                }
            })
        }

        // update 
        const {id} = user 

        trackPromise(
            auth.updateUserPassword({...vals, id})
                .then(() => {
                    notification.success({
                        message: "Password update",
                        description: "Password has been updated succesfully"
                    })

                    // clear fields 
                    form.resetFields()
                }).catch(err => {
                    notification.error({
                        message: "Password update failed",
                        description: "An error occured when updating password. Check console for details."
                    })

                    console.log(err.message)
                }), 'update_password'
        )
    }

    const {promiseInProgress} = usePromiseTracker({area: 'update_password'})

    return (
        <Form 
            layout="vertical" 
            id="update_password" 
            name="password_form"
            form={form}
            onFinish={updatePassword}
        >
            <Form.Item label="New password" name="password" rules={[{required: true, message: 'Password is required'}]}>
                <Input.Password />
            </Form.Item>
            <Form.Item label="Confirm password" name="password_confirm" rules={[{required: true, message: 'Password confirmation is required'}]}>
                <Input.Password />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" loading={promiseInProgress}>Update password</Button>
            </Form.Item>
        </Form>
    )
}

UpdatePassword.propTypes = {
    /** currently logged in user */
    user: PropTypes.object
}

export default UpdatePassword